import { render, staticRenderFns } from "./OpsPhone.vue?vue&type=template&id=f4d04416&scoped=true"
import script from "./OpsPhone.vue?vue&type=script&lang=js"
export * from "./OpsPhone.vue?vue&type=script&lang=js"
import style0 from "./OpsPhone.vue?vue&type=style&index=0&id=f4d04416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d04416",
  null
  
)

export default component.exports